import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { FloorManager } from "@/features/floor/components/floor-manager";
import { RestaurantGate } from "@/features/pos/components/restaurant-gate";
import { useActiveContext } from "@/features/pos/hooks/use-active-context";
import { useI18n } from "@/providers/i18n-provider";

function FloorPage() {
  const { t } = useI18n();
  const ctx = useActiveContext();
  return (
    <PageContainer maxWidth="4xl">
      <PageHeader title={t(msg`Floor`)} />
      <RestaurantGate ctx={ctx}>
        {(c) => <FloorManager org={c.org} branch={c.branch} />}
      </RestaurantGate>
    </PageContainer>
  );
}

export const floorRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/floor",
  component: FloorPage,
});
